import { useMpsPhone } from '~/composables/digital-lecture/use-mps-phone'

/**
 * Сохраняет телефон пользователя (mps_user_phone) из URL в cookie для страниц /digital-lecture.
 * Просмотр лекции фиксируется по этому телефону, если пользователь не авторизован.
 */
export default defineNuxtRouteMiddleware(to => {
  if (!to.path.startsWith('/digital-lecture')) {
    return
  }

  const phone = to.query.mps_user_phone
  if (phone) {
    const { setMpsPhone } = useMpsPhone()
    setMpsPhone(String(phone))
  }
})